import React, { useEffect, useRef } from 'react';
import styles from './accountblock.module.css';
import classNames from "classnames";
import {useNavigate} from 'react-router-dom'

const AccountBlock = ({ icon, heading, text, cta, link, background, target, orientation }) => {
  const navigate = useNavigate();

  function onClickLink() {
    if (link && target) {
      window.open(link, target ? target : "_self");
    } else {
      navigate(link)
    }
  }

  useEffect(() => {
    // Any animation or side effects can be handled here
  }, []);

  return (
    <span className={classNames(styles.accountBlock, orientation ? styles[orientation] : '')} style={{backgroundColor: background}} target={target ? target : "_self"} rel="noreferrer">
      <div className={styles.accountBlockIcon}>{icon}</div>
      <div className={styles.accountBlockContent}>
        <h3>{heading}</h3>
        {text && <p>{text}</p>}
        {cta && <span onClick={onClickLink} className={styles.accountBlockBtn}>{cta}</span>}
      </div>
    </span> 
  );
};

export default AccountBlock;